export default __webpack_public_path__ + "6b92bedc2dc041eddacab1d463cf3259.svg";